import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { AccordionContent, AccordionHeader, AccordionIcon, AccordionList } from './styles';
import { PromoIcon } from '../PromoIcon/PromoIcon';

export const Accordion = (props) => {
    const [openedIndex, setOpenedIndex] = useState(null);
    const showHideAccordion = (e, index) => {
        e.preventDefault();
        if (index === openedIndex) {
            setOpenedIndex(null);
        } else {
            setOpenedIndex(index);
        }
    };
    const toggleItem = (e, index, id) => {
        e.preventDefault();
        if (index === openedIndex) {
            setOpenedIndex(null);
        } else {
            setOpenedIndex(index);
        }
        props.sendEvent?.(id);
    };

    return (
        <AccordionList>
            {props.items
                .filter((item) => item !== null)
                .map((item, index) => {
                    return (
                        <li key={index}>
                            <AccordionHeader tabIndex={'0'} onClick={(e) => toggleItem(e, index, item.id)} onKeyPress={(e) => showHideAccordion(e, index)}>
                                {item.header}
                                <AccordionIcon>
                                    <PromoIcon name={openedIndex === index ? 'minus' : 'plus'} size="24px" color="baseColor" />
                                </AccordionIcon>
                            </AccordionHeader>
                            {openedIndex === index && <AccordionContent>{item.content}</AccordionContent>}
                        </li>
                    );
                })}
        </AccordionList>
    );
};

Accordion.propTypes = {
    items: PropTypes.array,
};
